import { SelectOption } from '../models';

export enum CalculMethod {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL',
  NO_CABLES = 'NO_CABLES',
}

export class CalculMethodHelper {
  private static readonly calculMethodLabelMap: Record<CalculMethod, string> = {
    [CalculMethod.AUTOMATIC]: 'Automatic',
    [CalculMethod.MANUAL]: 'Manual',
    [CalculMethod.NO_CABLES]: 'No cables',
  };

  static enumToLabelKey(calculMethod: CalculMethod): string {
    return this.calculMethodLabelMap[calculMethod] ?? '';
  }

  private static getConstantList(): CalculMethod[] {
    return [
      CalculMethod.AUTOMATIC,
      CalculMethod.MANUAL,
      CalculMethod.NO_CABLES,
    ];
  }

  static getOptions(): SelectOption[] {
    return this.getConstantList().map((calculMethod) => ({
      label: this.enumToLabelKey(calculMethod),
      value: calculMethod,
    }));
  }
}
